import type { DriverData } from 'screens/DriverManager/DriverManager.types'
import { type VehicleData, VehicleType } from 'screens/VehicleManager/VehicleManager.types'
import type { StopLegPair, GeoPoint, DangerousGoodsDetails } from 'screens/TripDetails/TripDetails.types'

export type CountersData = Record<string, number>

export type BranchesData = Record<string, string>

export interface TripData {
  entityId: string
  physicalSender: string
  logicalSender: string
  groupId: string
  tripNumber: string
  creationDate: string
  sendingApplication: string
  status: string
  numberOfShipments: number
  numberOfStops: number
  earlyPickUpDate?: string | null
  lateDeliveryDate?: string | null
  pickUpPlace?: string | null
  countryCodePickUpPlace?: string | null
  countryPickUpPlace?: string
  pickUpGeoPoint?: GeoPoint
  deliveryPlace?: string | null
  countryCodeDeliveryPlace?: string | null
  countryDeliveryPlace?: string
  deliveryGeoPoint?: GeoPoint
  totalWeight: number
  totalWeightWithUnit: MeasurementWithUnit
  totalVolume: number
  totalVolumeWithUnit: MeasurementWithUnit
  totalLoadingMeters: number
  totalLoadingMetersWithUnit: MeasurementWithUnit
  totalItems: number
  totalNumberOfPallets: number
  assignedDriverId?: string
  assignedDriver?: DriverData
  assignedTrailerIdentifier?: string
  assignedTrailer?: VehicleData
  assignedTruckIdentifier?: string
  assignedTruck?: VehicleData
  trackingInformation?: TrackingInformation
  temperatureControlled: boolean
  lastTrackedTemperature?: number
  lastTemperatureTimestamp?: string // deprecated
  lastTrackedPosition?: GeoPoint
  lastTrackedTimestamp?: string // deprecated
  dangerousGoodsDetails: DangerousGoodsDetails[]
  voyageNumber: string
  shipmentNumbers: string[]
  flags: TripFlag[]
  carrierInstructions?: string
  isCustomsRequired: boolean
  customerReferences: string[]
  mappedSender: string
  lastShareChannel?: string
  lastShareTimestamp?: string
  tripAcceptanceStatus: string
  qrToken?: string | null
}

export interface TripFlag {
  name: string
  wayPointCids?: string[]
}

export interface MeasurementWithUnit {
  value: number
  unitOfMeasurement: string
}

export interface StopsLocationGroup {
  id: string
  geoPoint: GeoPoint
  stopLegPairs: StopLegPair[]
}

export interface AssignDriverFormValues {
  driverCid: string | null
}

export interface AssignVehicleFormValues {
  licensePlate: string | null
  vehicleType: VehicleType | null
  isTrackable: boolean
}

export interface ShareTripViaEmailFormValues {
  weblink: string
  email: string
  language: string
}

export interface ShareTripViaSmsFormValues {
  weblink: string
  phoneNumber: string
  language: string
}

export interface ShareTripViaWhatsAppFormValues {
  mode: 'START_SESSION' | 'REPLACE_SESSION' | 'SEND_WEBLINK'
  weblink: string
  phoneNumber: string
  language: string
}

export interface SmsDriverFormValues {
  body: string
  phoneNumber: string
}

export interface TrackingInformation {
  tripCid: string
  trackingStatus: TrackingStatus
  positionTrackingStatus: TrackingHealth
  temperatureTrackingStatus: TrackingHealth
}

export enum TrackingStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  STOPPED = 'STOPPED',
}

export enum TrackingHealth {
  NONE = 'NONE',
  UNHEALTHY = 'UNHEALTHY',
  HEALTHY = 'HEALTHY',
}